module.exports = __webpack_public_path__ + "static/img/img_title_cn.639822b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newYear-2023/img_title_cn.png
// module id = rruY
// module chunks = 1